import script from "./webPc.vue?vue&type=script&setup=true&lang=js"
export * from "./webPc.vue?vue&type=script&setup=true&lang=js"

import "./webPc.vue?vue&type=style&index=0&id=cbe1d826&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Administrator\\Desktop\\项目\\公司\\cloudeffective-official-website-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbe1d826"]])

export default __exports__